import { render, staticRenderFns } from "./DiffReleaseEvent.vue?vue&type=template&id=749571f3&scoped=true&"
import script from "./DiffReleaseEvent.vue?vue&type=script&lang=js&"
export * from "./DiffReleaseEvent.vue?vue&type=script&lang=js&"
import style0 from "./DiffReleaseEvent.vue?vue&type=style&index=0&id=749571f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749571f3",
  null
  
)

export default component.exports